import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/FundMultiselectEntity';
import Popup from '../Common/Popup';

function FundStatusFilter({
    FundStatusOptions,
    setFundStatusOptions,
    customPathname,
    updateSubOptions,
    FundStatusSuboptions,
    isSuboptionsFetch,
    setFundStatusSuboptions,
    label = "Status",
    isPopupOpen,
    setIsPopupOpen
}) {

    const { FundStatus, refineSearchFilters } = useContext(PeFilterContext);
    
    // Use internal state only if props are not provided (for backward compatibility)
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    console.log(isSuboptionsFetch, "fetch");

    /* The `useEffect` hook is used to perform side effects in a functional component. In this case,
    the `useEffect` hook is used to update the `FundStatusOptions` state based on the `FundStatus`
    and `refineSearchFilters` values. */
    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.fundStatus?.map(value => value.id) ?? [];
        if (industryIds?.length === 0) {
            updateSubOptions("");
        }
        setFundStatusOptions(FundStatus?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.id) })));
    }, [FundStatus, customPathname, refineSearchFilters, setFundStatusOptions]);

    /**
     * The handleChange function updates sub-options and fund status options based on the selected
     * value.
     * @param e - The parameter `e` is an event object that is passed to the `handleChange` function.
     * It represents the event that triggered the function, such as a change event on an input element.
     */
    const handleChange = (e) => {
        const value = e.target.value;
        updateSubOptions(value);
        setFundStatusOptions(FundStatusOptions?.map(type => ({ ...type, isChecked: value === "" ? false : type.id === parseInt(value) })));
    };

    /**
     * The function `handleSubChange` updates the `isChecked` property of an array of objects based on
     * the user's selection.
     * @param e - The parameter `e` is an event object that is passed to the `handleSubChange`
     * function. It represents the event that triggered the function, such as a click event on a
     * checkbox.
     */
    const handleSubChange = (e) => {
        const { name, checked, id } = e.target;
        let currentIndustry = [];

        if (name === "allSelect") {
            currentIndustry = FundStatusSuboptions.map((industry) =>
                ({ ...industry, isChecked: checked })
            );
            setFundStatusSuboptions(currentIndustry);
        } else {
            currentIndustry = FundStatusSuboptions.map((industry) =>
                industry.id === parseInt(id) ? { ...industry, isChecked: checked } : industry
            );
            setFundStatusSuboptions(currentIndustry);
        }
    };

    const selected = FundStatusOptions?.filter(option => option.isChecked)?.at(0);
    const selectedSubCount = FundStatusSuboptions?.filter(option => option.isChecked)?.length ?? 0;

    const getDisplayText = () => {
        if (selected?.name && selectedSubCount > 0) {
            return `: ${selected.name} (${selectedSubCount})`;
        } else if (selected?.name) {
            return `: ${selected.name}`;
        }
        return "";
    };

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {FundStatus.slice(0,2).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {(selected?.name || selectedSubCount > 0) && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {getDisplayText()}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    {/* <div className="p-4 min-w-[300px]"> */}
                    <div className="p-4 min-w-[225px] md:min-w-[300px]">
                        <div className="mb-3">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Fund Status
                            </label>
                            <select 
                                value={selected?.id ?? ""} 
                                onChange={handleChange}
                                className="w-full p-2 border border-[#BC8B20] rounded focus:outline-none bg-white"
                            >
                                <option value="">Select</option>
                                {FundStatusOptions && FundStatusOptions.length > 0 ? (
                                    FundStatusOptions.map((investorType, index) => (
                                        <option key={investorType.id} value={investorType.id}>
                                            {investorType.name}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No results found!</option>
                                )}
                            </select>
                        </div>

                        {isSuboptionsFetch ? (
                            <p className='w-full py-1 text-center font-sans_light_body text-gray-500'>
                                Loading sub-options...
                            </p>
                        ) : FundStatusSuboptions?.length !== 0 ? (
                            <div className="mt-3">
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    Close Status
                                </label>
                                <div className="max-h-48 overflow-y-auto border border-gray-300 rounded p-2">
                                    <MultiSelectEntity
                                        handleEntityChange={handleSubChange}
                                        primaryEntity={FundStatusSuboptions}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default FundStatusFilter;